module.exports = __webpack_public_path__ + "static/media/55_000075.7e84af12.jpg";